import type { AppConfig, LayerConfig, ThemeConfig } from '../api/types';
import { defaultVisibility, pruneTree } from './tree';

/** Themes in project order; ids the project lists but the config lacks are skipped. */
export function orderedThemes(config: Pick<AppConfig, 'project' | 'themes'>): ThemeConfig[] {
  const byId = new Map(config.themes.map((t) => [t.id, t]));
  return config.project.themes.flatMap((id) => {
    const t = byId.get(id);
    return t ? [t] : [];
  });
}

export function layerIndex(layers: readonly LayerConfig[]): Map<string, LayerConfig> {
  return new Map(layers.map((l) => [l.id, l]));
}

export function themeDefaults(theme: ThemeConfig, layers: ReadonlyMap<string, LayerConfig>): Record<string, boolean> {
  return defaultVisibility(pruneTree(theme.tree, new Set(layers.keys())), layers);
}
